import React from 'react';
import { useSelector } from 'react-redux';
import { limitOverTimeData } from '../../../../index';

import { Copy, Loading, Modal, StringHelpers, SystemText } from 'e4shared';

import Chart from 'chart.js';
import { apiGet } from 'services';
import { e4Format, e4Formats } from 'helpers/dates';

export const MetricsOverTime = ({ job, profile, range, show, close }) => {
    const [loading, setLoading] = React.useState(true);
    const [overtime, setOvertime] = React.useState([]);

    const user = useSelector(state => state.user.user);
    const staff = job?.type === 'M';

    const st = (path, ...rest) => SystemText(`User121/Metrics/Overtime/${path}`, ...rest);

    React.useEffect(() => {
        if (show) {
            setLoading(true);
            apiGet(
                `crm-over-time/${profile.id}/${job.job_Id}?staff=${staff}&range=${range || 'month'}`,
                user.guid,
                response => {
                    setOvertime(response);
                    setLoading(false);
                }
            );
        }
    }, [show]);

    if (!profile || !job) return null;

    if (loading)
        return (
            <Modal
                data-testid="modal-crm-over-time-loading"
                show={show}
                title={st('Title', user.crmIntegration)}
                close={close}
            >
                <Loading />
            </Modal>
        );

    const data = {
        datasets: [
            {
                label: job.legend,
                data: limitOverTimeData(overtime).map(r => ({
                    x: r.date_Set,
                    y: r.value,
                })),
                backgroundColor: 'rgba(99, 255, 132, 0.2)',
                borderColor: 'rgba(99, 255, 132, 1)',
                borderWidth: 1,
            },
        ],
    };

    const options = {
        tooltips: {
            callbacks: {
                title: function (tooltipItem, data) {
                    return e4Format(tooltipItem[0].xLabel, range === 'week' ? e4Formats.default : e4Formats.month);
                },
                label: function (tooltipItem, data) {
                    return StringHelpers.formatMetric(job.format, tooltipItem.yLabel, user.currencySymbol);
                },
            },
        },
        showLine: true,
        legend: {
            display: true,
        },
        scales: {
            xAxes: [
                {
                    type: 'time',
                    time: {
                        unit: 'month',
                    },
                },
            ],
            yAxes: [
                {
                    name: job.name,
                    position: 'left',
                    ticks: {
                        precision: 0,
                        suggestedMin: 0,
                        callback: function (label, index, labels) {
                            return StringHelpers.formatMetric(job.format, label, user.currencySymbol);
                        },
                    },
                    gridLines: { display: false },
                },
            ],
        },
    };

    const canvas = `chart-${profile.id}-${job.id}-${range}`;
    let chart = null;

    setTimeout(() => {
        chart = new Chart(canvas, {
            id: canvas,
            type: 'bar',
            data,
            options,
        });
    }, 500);

    return (
        <Modal data-testid="modal-crm-over-time" show={show} title={st('Title', user.crmIntegration)} close={close}>
            <span>
                <p className="text-sm">
                    <Copy value={st(staff ? 'Graph/Summary/Team' : 'Graph/Summary/User', profile.full_Name, job.name)} />
                </p>
            </span>
            <canvas data-testid="chart-crm-over-time" id={canvas} key={canvas} width="100%" height="50%" />
            {job.format === 'R' && (
                <div className="text-sm text-center">
                    <br />
                    <br />
                    <p>{st('Graph/Ratio')}</p>
                </div>
            )}
        </Modal>
    );
};

export default MetricsOverTime;
